import React, { useState, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import Table from './Table';
import formatDate from '../helpers/formatDate';

export default function UsersTable() {
  const [ffData, setFFData] = useState([]);
  const [loadingFFData, setLoadingFFData] = useState(false);

  useEffect(() => {
    setLoadingFFData(true)
    async function fetchData() {
      const response = await fetch("api/users");
      const res = await response.json();
      return (res)
    }
    // call the function
    fetchData()
      .then((res) => {
        setFFData(res.data)
        setLoadingFFData(false)
      })
      // make sure to catch any error
      .catch(console.error);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'FF ID',
      },
      {
        accessorKey: 'email',
        header: 'Email',
      },
      {
        accessorFn: (row) => row.brokers.filter(b => [1,11].includes(b.hubspot_token_id))
          .map(broker => `HS TOKEN: ${broker.hubspot_token_id} -- ${broker.agency.name}: ${broker.email}`).join(', '),
        cell: (info) => info.row.original.brokers.filter(b => [1,11].includes(b.hubspot_token_id))
          .sort((a, b) => {
            if (a.hubspot_token_id !== b.hubspot_token_id) {
              return a.hubspot_token_id - b.hubspot_token_id;
            }
            return a.agency.name.localeCompare(b.agency.name);
          })
          .map(broker => <div key={broker.id}>{`HS TOKEN: ${broker.hubspot_token_id === 11 ? 'Carpool' : 'Fastlane'} -- ${broker.agency.name}: ${broker.email}`}</div>),
        header: 'Broker Accounts',
      },
      {
        header: 'Active',
        accessorFn: (row) => row.active ? 'Yes' : 'No',
      },
      {
        header: 'Sign In Count',
        accessorFn: (row) => row.sign_in_count,
        filterFn: (row, columnId, filterValue) => {
          if (filterValue === '' || filterValue === undefined || filterValue === null) return true;
          return String(row.getValue(columnId)) === String(filterValue);
        },
        meta: { filterVariant: 'number', width: '90px' },
      },
      {
        accessorFn: (row) => formatDate(row.last_sign_in_at),
        header: 'Last Sign In',
      },  
      ],
    [],
  )

  return (
    <div className="border bg-white p-3">
      <Table
        loadingFFData={loadingFFData}
        data={ffData}
        columns={columns}
      />
    </div>
  );
};

const element = document.getElementById('users-table');
if (element) {
  const root = createRoot(element);
  root.render(<UsersTable/>);
}